// extracted by mini-css-extract-plugin
export default {"school-select-form":"Q572l7N6vQareBzmlDQY","container":"jZ2koOrrhmimaB41hX4A","wide":"TCyMuvVmhUsWiQQhUtGe","cancel-wrapper":"AI4uemDGkBwIQrHo0akH","btn":"rJVOR0O73j2WJSYEuK50"};